import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from '../../../../../Containers/Config/index.js';
import { CONFIRM_BOOKING_GOLF, CONFIRM_BOOKING_GOLF_SUCCESS, CONFIRM_BOOKING_GOLF_ERROR } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

const getCurrentTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

function* confirmBookingGolf({ payload }) {
  try {
    const isUaeProject = ['CBD_GOLF_V2', 'VISA_PVT', 'MASTERCARD_UAE', 'MASHREQ'].includes(Constant?.PROJECT_CODE);
    const baseUrl = isUaeProject ? thriweMarketPlaceUaeUrl : thriweMarketPlaceUrl;
    const response = yield call(apiCall, {
      url: `${baseUrl}/v2/admin/confirm-booking`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'x-timezone': getCurrentTimezone(),
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CONFIRM_BOOKING_GOLF_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CONFIRM_BOOKING_GOLF_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CONFIRM_BOOKING_GOLF_ERROR, payload: error });
  }
}

export function* watchConfirmBookingGolf() {
  yield takeEvery(CONFIRM_BOOKING_GOLF, confirmBookingGolf);
}

function* confirmBookingGolfSaga() {
  yield all([fork(watchConfirmBookingGolf)]);
}

export default confirmBookingGolfSaga;
